import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ACCESS_TOKEN } from "../constants/auth";
import { useQuery } from "@tanstack/react-query";
import { fetchProfile } from "../api/services";
import Loader from "./Loader";
import { useGetProfile } from "@/api/profile";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const token = localStorage.getItem(ACCESS_TOKEN);

  const { isLoading, isError } = useGetProfile();

  useEffect(() => {
    if (!token) {
      navigate(`/auth?${searchParams.toString()}`);
    } else {
      searchParams.delete("email");
      setSearchParams(`?${searchParams.toString()}`);
    }
  }, [token, navigate, searchParams, setSearchParams]);

  useEffect(() => {
    if (isError) {
      localStorage.removeItem(ACCESS_TOKEN);
      navigate(`/auth?${searchParams.toString()}`);
    }
  }, [isError, navigate, searchParams]);

  if (isLoading) {
    return <Loader />;
  }

  if (!token || isError) {
    return null;
  }

  return <>{children}</>;
}
